import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { ITournamentParticipant } from "redux/reducers/models/tournament";

const apiVersion = "2024-04";
const adminType = "facility-admin";
const baseUrl = "/" + apiVersion + "/" + adminType + "/tournament";

export type TGetTournamentParticipant = {
  tournament_id?: string | number;
};

type DeleteTournamentParticipant = {
  id?: number;
  tournament_id?: number;
  participant_id?: number;
};

type TExportTournamentParticipants = {
  tournament_id: number;
  type: "csv";
};

export interface IPostTournamentParticipantNew {
  tournament_id: string | number;
  first_name: string;
  last_name: string;
  email?: string;
  phone?: string;
}

export async function GetTournamentParticipant(
  params: TGetTournamentParticipant,
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet<ITournamentParticipant[]>(
    APIUrl(AdminType.FacilityAdmin, "/tournament/participant"),
    params,
    useGlobalLoader,
    token,
  );
}

//Delete player within a tournament
export async function DeleteTournamentParticipant(params: DeleteTournamentParticipant, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/tournament/participant"), params, useGlobalLoader);
}

//Copy tournament players to another tournament
export async function CopyTournamentParticipants(params: any, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tournament/participant/copy"), params, useGlobalLoader);
}

//Import Tournament Players
export async function ImportTournamentPlayers(params: any, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/tournament/participant/import"), params, useGlobalLoader);
}

// Export Tournament Players
export async function PutExportParticipants(params: TExportTournamentParticipants, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tournament/participant/export"), params, useGlobalLoader);
}

export interface IPostTournamentParticipant {
  tournament_id: string | number;
  customer_id: string | number;
  first_name?: string;
  last_name?: string;
  email?: never;
  phone?: never;
}
export interface IPostTournamentParticipantNew {
  tournament_id: string | number;
  first_name: string;
  last_name: string;
  email?: string;
  phone?: string;
}

// Add player to tournament
export async function PostParticipant(
  params: IPostTournamentParticipant | IPostTournamentParticipantNew,
  useGlobalLoader: boolean,
) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/tournament/participant"), params, useGlobalLoader);
}

// Update player to tournament
export async function PutParticipant(params: any, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tournament/participant"), params, useGlobalLoader);
}
